/**
 * i18n Module
 * Initializes and configures i18next for React
 * App languages: `en` | `ua` only.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { i18nConfig } from './i18n.config';
import { sharedResources } from '../app/i18n';

const uaBundle = {
  common: sharedResources.uk.common,
  validation: sharedResources.uk.validation,
  errors: sharedResources.uk.errors,
  auth: sharedResources.uk.auth,
};

const resources = {
  en: {
    common: sharedResources.en.common,
    validation: sharedResources.en.validation,
    errors: sharedResources.en.errors,
    auth: sharedResources.en.auth,
  },
  ua: uaBundle,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...i18nConfig,
    resources,
    compatibilityJSON: 'v3',
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'language',
      caches: ['localStorage'],
      convertDetectedLanguage: (lng: string) => {
        const code = lng.toLowerCase();
        if (code.startsWith('uk') || code.startsWith('ua')) {
          return 'ua';
        }
        return code.split('-')[0];
      },
    },
  });

export default i18n;
